/**
 * Created by Administrador on 21/11/2018.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('modifyValidityService', modifyValidityService);

    modifyValidityService.$inject = ['$http', 'CONFIG', 'messageService'];


    function modifyValidityService($http, CONFIG, messageService){

        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_PNR + '/' + CONFIG.API;

        var service = {
            getSearchPnr: getSearchPnr,
            updateExtensionValidDate: updateExtensionValidDate,
            saveModifyValidity: saveModifyValidity
        };

        return service;

        function getSearchPnr(pnrCode){
            return $http.get(urlBase +"/pnr/search?pnrCode=" + pnrCode)
                .then(function(response){
                    return response.data;
                })
                .catch(function(){
                    messageService.findAllError('');
                });
        }

        function updateExtensionValidDate(operationSale, userLogin){
            return $http.put(urlBase + "/pnr/update/pnr/extensionValidDate?user_login=" + userLogin, operationSale)
                .then(function(response){
                    messageService.registerUpdate('');
                    return response;
                })
                .catch(function(err){
                    messageService.registerUpdateError('')
                    return err;
                });
        }

        function saveModifyValidity(rbcModifyPenalty){
            return $http.post(urlBase + "/modificationPenalties", rbcModifyPenalty)
                .then(function(response){
                    messageService.registerUpdate('');
                    return "ok";
                })
                .catch(function(){
                    messageService.withoutPermission('')
                    return "error";
                });
        }
    }
})();
